"use strict";
const pluginVersion = "12.2.1";
var PointShape = /* @__PURE__ */ ((PointShape2) => {
  PointShape2["Circle"] = "circle";
  PointShape2["Square"] = "square";
  return PointShape2;
})(PointShape || {});
var SeriesMapping = /* @__PURE__ */ ((SeriesMapping2) => {
  SeriesMapping2["Auto"] = "auto";
  SeriesMapping2["Manual"] = "manual";
  return SeriesMapping2;
})(SeriesMapping || {});
var XYShowMode = /* @__PURE__ */ ((XYShowMode2) => {
  XYShowMode2["Lines"] = "lines";
  XYShowMode2["Points"] = "points";
  XYShowMode2["PointsAndLines"] = "points+lines";
  return XYShowMode2;
})(XYShowMode || {});
const defaultMatcherConfig = {
  id: ""
};
const defaultFieldConfig = {
  fillOpacity: 50,
  show: "points" /* Points */
};
const defaultOptions = {
  series: []
};

export { PointShape, SeriesMapping, XYShowMode, defaultFieldConfig, defaultMatcherConfig, defaultOptions, pluginVersion };
